import $ from 'jquery'
const md5 = require('md5');
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
import aliyunoss from "./oss";
import axios from 'axios';
export const BzOss = {
    toUploadOss(obj) {
        return new Promise((resolve, reject) => {
            let token = BzAjax.getkey()
            console.log(token)
            var configoss = {
                url: BzConfig.OsUrl + "/WSD/Oss/Config?token=" + token
            };
            let oss = new aliyunoss(configoss);

            var form = new FormData();
            form.fileName = obj.name
            oss.formdataappend(form, function () {
                form.append("file", obj);
                let config2 = {
                    headers: { 'Content-Type': 'multipart/form-data' }
                };  //添加请求头
                axios.post(oss.host, form, config2)
                    .then(response => {
                        resolve(response.data)
                        console.log(response.data, 'response.data');
                    })

            });
        })

    },

};
export const BzAjax = {
    postOs: function (requesturl, json, callback, ErrorCallback) {
        if (requesturl.indexOf("?") > 0) {
            requesturl = requesturl + "&token=" + this.getkey();
        } else {
            requesturl = requesturl + "?token=" + this.getkey();
        }
        const loading = Loading.service({
            lock: true,
            text: '数据加载中, 请稍后',
            background: 'rgba(0, 0, 0, 0.5)'
        });
        $.ajax({
            type: "post",
            url: BzConfig.OsUrl + requesturl,
            data: JSON.stringify(json),
            dataType: "json",
            contentType: "application/json",
            success: function (data) {
                loading.close();
                if (data.Status == 0) {
                    callback(data.Data)
                } else {
                    if (ErrorCallback == undefined)
                        BzMsg.ShowErr(data.ErrorMessage)
                    else
                        ErrorCallback(data);
                }
            },
            error: function (XHR, textStatus, errorThrown) {
                loading.close();
                BzMsg.ShowErr(XHR.responseJSON.Message)
                //alert("XHR=" + JSON.stringify(XHR) + "\ntextStatus=" + textStatus + "\nerrorThrown=" + errorThrown);
            }

        });
    },

    getsynch: function (requesturl, callback) {
        requesturl = requesturl + "?token=" + this.getkey();

        $.ajax({
            type: "get",
            url: apiurl + requesturl,
            dataType: "json",
            async: false,
            success: function (data) {
                BzMsg.Loading(false)
                callback(data)
            },
            error: function (XHR, textStatus, errorThrown) {
                BzMsg.Loading(false)
                BzMsg.ShowErr(XHR.responseJSON.Message)
            }

        });
    },
    get2synch: function (requesturl, json, callback) {
        requesturl = requesturl + "?token=" + this.getkey();
        for (var j in json) {
            requesturl += "&" + j + "=" + json[j]
        }

        $.ajax({
            type: "get",
            url: apiurl + requesturl,
            dataType: "json",
            async: false,
            success: function (data) {
                BzMsg.Loading(false)
                callback(data)
            },
            error: function (XHR, textStatus, errorThrown) {
                BzMsg.Loading(false)
                BzMsg.ShowErr(XHR.responseJSON.Message)
            }

        });
    },
    getkey: function () {
        var users = BzUser.get();
        var loginid = users.sumirryname;
        var key = users.sumirrykey;
        var g = this.nokey();
        var sendkey = g + key;
        return g + md5(sendkey).substring(8, 24).toLowerCase() + loginid
    },
    nokey: function () {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + S4() + S4());
    },
    get: function (requesturl, callback) {
        requesturl = requesturl + "?token=" + this.getkey();

        $.ajax({
            type: "get",
            url: BzAjax.apiurl + requesturl,
            dataType: "json",
            success: function (data) {
                BzMsg.Loading(false)
                callback(data)
            },
            error: function (XHR, textStatus, errorThrown) {
                BzMsg.Loading(false)
                BzMsg.ShowErr(XHR.responseJSON.Message)
            }

        });
    },
    get2: function (requesturl, json, callback) {
        requesturl = requesturl + "?token=" + this.getkey();
        for (var j in json) {
            requesturl += "&" + j + "=" + json[j]
        }

        $.ajax({
            type: "get",
            url: BzAjax.apiurl + requesturl,
            dataType: "json",
            success: function (data) {
                BzMsg.Loading(false)
                callback(data)
            },
            error: function (XHR, textStatus, errorThrown) {
                BzMsg.Loading(false)
                BzMsg.ShowErr(XHR.responseJSON.Message)
            }

        });
    },
    getexporturl(requesturl, json, modelname) {
        requesturl = requesturl + "?token=" + this.getkey();

        requesturl += "&" + modelname + "=" + JSON.stringify(json)

        return BzAjax.apiurl + requesturl;
    }

};

export const BzMsg = {
    loadingInstance: {
        close() {

        }
    },
    ShowMsg: function (msg, callback) {
        MessageBox.alert(msg, '消息提示', {
            confirmButtonText: '确定',
            callback: callback
        });
        // Message.success({
        //     showClose: true,
        //     message: msg,
        //     type: 'success'
        // });
    },
    ShowErr: function (msg, callback) {
        Message.success({
            showClose: true,
            message: msg,
            type: 'error'
        });
    },
    ShowAsk: function (msg, callback) {
        MessageBox.confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(() => {
                callback()
            })
            .catch(() => {

            });

    },
    InputBox: function (options, callback) {


    },
    Loading: function (n, t) {
        if (n == true) {
            t == undefined ? "正在为您拼命加载。。。" : t
            this.loadingInstance = Loading.service({
                lock: true,
                text: t,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        } else {
            this.loadingInstance.close();
        }

    }
};
export const BzUser = {
    get: function () {
        var users = JSON.parse(localStorage.getItem("localuser"));
        if (users == null) {
            users = {};
            users.IsLogin = 0;

            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, 2).getTime() < new Date().getTime()) {
            localStorage.removeItem("localuser");
            users.IsLogin = 0;
        } else {
            users.ExpiryDate = new Date();
            BzUser.setuser(users);
        }
        return users;
    },
    setuser: function (users) {
        localStorage.setItem("localuser", JSON.stringify(users))
    },
    deleteuser: function () {
        localStorage.removeItem("localuser");
    }
};
export const BzlocalStorage = {
    get: function (name, time) {
        var users = JSON.parse(localStorage.getItem(name));
        if (users == null) {
            users = {};
            users.IsEffective = 0;
            users.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        if (BzDate.addHours(users.ExpiryDate, time).getTime() < new Date().getTime()) {
            localStorage.removeItem(name);
            users.IsEffective = 0;
        } else {
            users.ExpiryDate = new Date();
            localStorage.setItem(name, JSON.stringify(users))

        }
        return users;
    },
    set: function (name, obj) {
        obj.ExpiryDate = BzDate.format(new Date(), "yyyy-MM-dd hh:mm:ss");
        obj.IsEffective = 1;
        localStorage.setItem(name, JSON.stringify(obj))
    },
    deleteuser: function (name) {
        localStorage.removeItem(name);
    }
};
export const BzStore = {
    get: function () {
        var localstore = JSON.parse(localStorage.getItem("localstore"));
        if (localstore == null) {
            localstore = {};
        }
        return localstore;
    },
    setstore: function (store) {
        var localstore = BzStore.get();
        for (var j in store) {
            localstore[j] = store[j];
        }
        localStorage.setItem("localstore", JSON.stringify(localstore))
    },
    deletestore: function () {
        localStorage.removeItem("localstore");
    }
};
export const BzDate = {
    format(formatdate, fmt) { //author: meizz 
        if (!(formatdate instanceof Date)) {
            formatdate = new Date(formatdate)
        }
        var o = {
            "M+": formatdate.getMonth() + 1, //月份 
            "d+": formatdate.getDate(), //日 
            "h+": formatdate.getHours(), //小时 
            "m+": formatdate.getMinutes(), //分 
            "s+": formatdate.getSeconds(), //秒 
            "q+": Math.floor((formatdate.getMonth() + 3) / 3), //季度 
            "S": formatdate.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (formatdate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

        return fmt;
    },
    //获取两个时间之间的间隔
    getTimeDiff(dateBegin, dateEnd, timetype) {
        var dateBegin = new Date(dateBegin);
        var dateEnd = new Date(dateEnd);
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
        switch (timetype) {
            case 1:
                return Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
            case 2:
                return Math.floor(leave1 / (3600 * 1000));//计算出小时数
            case 3:
                return Math.floor(leave2 / (60 * 1000));//计算相差分钟数
            case 4:
                return Math.round(leave3 / 1000);//计算毫秒数
        }
    },
    //判断第一个是不是比第二个大
    checkDate: function (Date1, Date2) {
        var oDate1 = new Date(Date1);
        var oDate2 = new Date(Date2);
        if (oDate1.getTime() > oDate2.getTime()) {
            return true;
        } else {
            return false;
        }
    },
    addMonth: function (pdate, n) {   // n个月后 
        var mydate = new Date(pdate);
        //当前月
        var m = mydate.getMonth() + 1;
        var y = mydate.getFullYear();
        var retdate = mydate.getTime();
        for (var i = 0; i < n + 1; i++) {
            retdate += BzDate.getMonthDay(y, m) * 86400000
            m++;
            if (m == 13) {
                y++;
                m = 1;
            }
        }

        return new Date(retdate);
    },
    getMonthDay: function (year, month) {
        if (month == 2) {
            if (year % 4 == 0 && year % 100 != 0)
                return 29;
            else
                return 28;
        }
        else if ((month <= 7 && month % 2 == 1) || (month > 7 && month % 2 == 0))
            return 31;
        else
            return 30;
    },
    addHours: function (date1, hours) {
        var mydate = new Date(date1);
        var time = mydate.getTime() + 1000 * 60 * 60 * hours;
        return new Date(time);
    }
};
export const BzJs = {
    replaceAll(str, oldstr, newstr) {
        return str.replace(new RegExp(oldstr, "gm"), newstr);
    },
    splitNumber(arrlength, number) {
        number = number.toString();

        var newarr = [];
        if (number.length < arrlength) {
            for (var i = number.length; i < arrlength; i++) {
                newarr.push(0);
            }
        }
        for (var i = 0; i < number.length; i++) {
            newarr.push(number.substr(i, 1))
        }

        return newarr;
    },
    guid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    },
    exportExcel(url) {
        const loadingInstance = Loading.service({
            lock: true,
            text: '正在为您导出，请耐心等待。。。',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        let iframe = document.createElement("iframe");
        iframe.src = url;

        iframe.style.display = "none";
        if (iframe.attachEvent) {
            iframe.attachEvent("onload", d => {

                loadingInstance.close();
            });
        } else {
            iframe.onload = function () {

                loadingInstance.close();
            };
        }
        document.body.appendChild(iframe);
        setTimeout(() => {
            loadingInstance.close();
        }, 1000);
    }
}
export const ElementConfig = {
    SystemDateOptions: {
        shortcuts: [
            {
                text: "最近一周",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近一个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                }
            },
            {
                text: "最近三个月",
                onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                }
            }
        ]

    }
}



// WEBPACK FOOTER //
// ./src/assets/script/utils.js